import { render, staticRenderFns } from "./ParkingBarriers.vue?vue&type=template&id=5bbf7c0b&scoped=true&"
import script from "./ParkingBarriers.vue?vue&type=script&lang=js&"
export * from "./ParkingBarriers.vue?vue&type=script&lang=js&"
import style0 from "./ParkingBarriers.vue?vue&type=style&index=0&id=5bbf7c0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbf7c0b",
  null
  
)

export default component.exports